import { render, staticRenderFns } from "./vSwitch.vue?vue&type=template&id=53ad9ab2&"
import script from "./vSwitch.vue?vue&type=script&lang=js&"
export * from "./vSwitch.vue?vue&type=script&lang=js&"
import style0 from "./vSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports